import HomeWordShader from '@/glxp/shaders/homeWord.glsl'
import HomePostShader from '@/glxp/shaders/homePost.glsl'
import GlitchPostShader from '@/glxp/shaders/glitchPost.glsl'
import BackgroundShader from '@/glxp/shaders/background.glsl'
import MarblingPostShader from '@/glxp/shaders/marblingPost.glsl'
import TransitionShakeShader from '@/glxp/shaders/transitionShake.glsl'
import ImageTransitionShader from '@/glxp/shaders/imageTransition.glsl'

import Unlit from '@/glxp/shaders/unlit.glsl'
import Cover from '@/glxp/shaders/cover.glsl'

export default {
  'shake': HomeWordShader,
  'unlit': Unlit,
  'unlit': Unlit,
  'cover': Cover,
  'background': BackgroundShader,
  'shake-post': HomePostShader,
  'glitch-post': GlitchPostShader,
  'marbling-post': MarblingPostShader,
  'transition-shake': TransitionShakeShader,
  'image-transition': ImageTransitionShader
}
